import { render } from "./TrainingInner.vue?vue&type=template&id=5cd38b36&scoped=true"
import script from "./TrainingInner.vue?vue&type=script&lang=js"
export * from "./TrainingInner.vue?vue&type=script&lang=js"

import "./TrainingInner.vue?vue&type=style&index=0&id=5cd38b36&scoped=true&lang=css"

import exportComponent from "/Users/ratitsiklauri/DevProjects/DK-Projects/recturing-front-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd38b36"]])

export default __exports__